export default "__VITE_ASSET__DG9zMj0$__"